/**
 * Small `?` icon that opens the documentation page (in a new tab) at a
 * specific section. Used across the Semantic Model page for
 * context-sensitive help.
 *
 * Usage: <HelpIcon docKey="aggregates-filters" label="Aggregate Filters" />
 */
import React from 'react';
import { HelpCircle } from 'lucide-react';
import { resolveDocKey } from '@/lib/helpRoutes';

export function HelpIcon({ docKey, label = 'Help', className = '' }) {
  const { section, heading } = resolveDocKey(docKey);
  const href = `/help?s=${encodeURIComponent(section)}${heading ? `&h=${encodeURIComponent(heading)}` : ''}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      title={`Learn more about ${label} — opens in a new tab`}
      aria-label={`Help: ${label}`}
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center justify-center w-4 h-4 rounded-full text-muted-foreground hover:text-indigo-300 transition-colors align-middle ${className}`}
      data-testid={`help-icon-${docKey}`}
    >
      <HelpCircle className="w-3.5 h-3.5" />
    </a>
  );
}

export default HelpIcon;
